<form [formGroup]="form">
  <div nz-row [nzGutter]="10">
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 8}">
      <beautyapp-input
        label="{{'realization.form.card' | translate}}"
        formControlName="cardNo"
        (ngModelChange)="checkUser()"
        size="large"
      ></beautyapp-input>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 8}">
      <beautyapp-input label="{{'realization.form.firstname' | translate}}" formControlName="firstname" [required]="true"
                       size="large"></beautyapp-input>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 8}">
      <beautyapp-input label="{{'realization.form.lastname' | translate}}" formControlName="lastname"
                       size="large"></beautyapp-input>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 8}">
      <beautyapp-input
        label="{{'realization.form.phoneNumber' | translate}}"
        formControlName="mobilePhone"
        [required]="true"
        (ngModelChange)="checkUser()"
        size="large"
      ></beautyapp-input>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 16}">
      <beautyapp-select
        label="{{'users.form.userSource' | translate}}"
        [data]="userSources()"
        displayMember="name"
        valueMember="id"
        formControlName="userSourceId"
        size="large"
      >
      </beautyapp-select>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 8}">
      <beautyapp-input
        label="{{'realization.form.idNumber' | translate}}"
        formControlName="identityNumber"
        [required]="personalIdRequired"
        [errors]="{ pattern: personalIdError }"
        size="large"
      ></beautyapp-input>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 8}">
      <beautyapp-select
        size="large"
        label="{{'realization.form.gender' | translate}}"
        [data]="genders"
        displayMember="value"
        valueMember="id"
        formControlName="gender"
      >
      </beautyapp-select>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 8}">
      <beautyapp-select
        size="large"
        label="{{'users.form.smsLanguage' | translate}}"
        [data]="smsLanguages"
        displayMember="value"
        valueMember="id"
        formControlName="smsLanguage"
      >
      </beautyapp-select>
    </div>

    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 8}">
      <beautyapp-datepicker
        size="large"
        formControlName="birthDate"
        [label]="'realization.form.dateOfBirth' | translate"
      ></beautyapp-datepicker>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 8}">
      <beautyapp-select
        label="{{'სისხლის ჯგუფი' | translate}}"
        [data]="bloodGroups"
        displayMember="alias"
        valueMember="value"
        formControlName="bloodGroup"
        size="large"
      >
      </beautyapp-select>
    </div>

    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 8}">
      <beautyapp-select
        label="{{'realization.form.country' | translate}}"
        [data]="countries()"
        displayMember="name"
        valueMember="id"
        formControlName="countryId"
        size="large"
      ></beautyapp-select>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 8}">
      <beautyapp-select
        label="{{'realization.form.city' | translate}}"
        [data]="cities()"
        displayMember="name"
        valueMember="id"
        formControlName="cityId"
        size="large"
      ></beautyapp-select>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 8}">
      <beautyapp-input size="large" label="{{'realization.form.address' | translate}}"
                       formControlName="address"></beautyapp-input>
    </div>

    <div nz-col [nzSpan]="24">
      <beautyapp-input size="large" label="{{'realization.form.workingPlace' | translate}}"
                       formControlName="workplace"></beautyapp-input>
    </div>
    <div nz-col  [nzSpan]="24">
      <beautyapp-textarea
        size="large"
        formControlName="description"
        [label]="'users.form.additionalInformation' | translate"
        placeholder="{{'users.form.additionalInformation' | translate}}"
      ></beautyapp-textarea>
    </div>
  </div>
</form>
<div *nzModalFooter>
  <div nz-row nzJustify="space-between" nzAlign="middle">
    <div nz-col>
      <label nz-checkbox [(ngModel)]="userVerification">{{ 'users.form.verification' | translate }}</label>
    </div>
    <div nz-col>
      <button nz-button nzType="default" (click)="modal.close()">{{ 'buttons.close' | translate }}</button>
      <button nz-button nzType="primary" (click)="submit()">{{ 'buttons.save' | translate }}</button>
    </div>
  </div>
</div>
